import ShowInfo from "@/components/poster/ShowInfo";
import { type ShowWithMovie } from "@/lib/client/getShowsAndMovies";
import { type VersionTag } from "@/lib/movieinfo/movieinfotypes";
import styles from "./MovieTitle.module.css";

import Link from "next/link";
//#region [Props]
type MovieTitleProps = ({
    show: ShowWithMovie;
    title?: never;

} | {
    show?: never;
    title: string;
}) & {
    href?: string;
};


//#endregion

//#region [Component]
export default function MovieTitle({ show, title, href }: MovieTitleProps) {
    if (!show && !title) return null;
    const text = <>{show?.movieTitle ?? title} {show && <ShowTags show={show} />}</>;
    return <h2 className={styles.MovieTitle}>
        {href && <Link href={href}>{text}</Link>}
        {!href && text}
    </h2>;
}

function ShowTags({ show }: { show: ShowWithMovie }) {
    if ((show.versionTags?.length ?? 0) === 0) return null;

    const versionName = getVersionName(show);
    if (!versionName) return null;
    return <ShowInfo info={versionName} className={styles.Tags} />
}

//#endregion

const EXCLUDE_TAGS = ["Norsk tekst", "2D"];
function getVersionName(show: ShowWithMovie) {
    const versionTags = (show.versionTags?.filter((versionTag) => !EXCLUDE_TAGS.includes(versionTag!.tag!)) ?? []) as VersionTag[];
    versionTags.sort((a, b) => {
        if (a.tag!.endsWith(" tale") && !b.tag!.endsWith(" tale")) {
            return -1;
        }
        if (!a.tag!.endsWith(" tale") && b.tag!.endsWith(" tale")) {
            return 1;
        }

        if (a.tag!.includes("tekst") && !b.tag!.includes("tekst")) {
            return 1;
        }
        if (!a.tag!.includes("tekst") && b.tag!.includes("tekst")) {
            return -1;
        }
        return 0;
    });

    if (show.showType) versionTags.push({ tag: show.showType, type: "" });

    const versionText = versionTags.length === 0 ? undefined : versionTags.map(t => t.tag).join(", ");
    return versionText;
}